import { UseQueryOptions } from 'react-query';
import { useAPI } from '@/services/index';

const PAGE_SIZE = 10;

export const useGetNotification = (
  reactQueryOptions?: UseQueryOptions<any>
) => {
  const response = useAPI(['notification', 'getNotifications'], {
    isInfinite: true,
    input: { pageIndex: 0, pageSize: PAGE_SIZE },
    reactQueryOptions: {
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage, pages) => {
        return lastPage?.length === PAGE_SIZE
          ? { pageIndex: pages.length }
          : undefined;
      },
      ...(reactQueryOptions ?? {}),
    },
  });

  const notifications = response?.data?.pages
    ?.map((item) => item)
    .flatMap((item) => item);

  const unseenCount: number =
    notifications?.filter((item) => !item.isSeen).length ?? 0;

  return {
    response,
    ...response,
    notifications,
    unseenCount,
  };
};
